module.exports = __webpack_public_path__ + "img/visa.de2a9db5.png";